export const Routes = {
	Home: "/",
	Episode: (guid: string) => "/episode/" + guid,
	NotFound: "/404"
};